import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { MenuItem } from '../models';
import { MenuService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class MenuItemResolver {
  private readonly menuService = inject(MenuService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MenuItem> {
    return this.menuService.menuItem(state.url);
  }
}
